//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "ROSIERSIGLE",
  data() {
    return {
      form: {
        syncope: "0",
        epilepsy: "0",
        myasthenia: "0",
        upperLimbWeakness: "0",
        lowerLimbWeakness: "0",
        speechDisorders: "0",
        visual: "0",
      },
      hasScore: false,
      disabled: false,
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        let result =
          (form.syncope ? -1 : 0) +
          (form.epilepsy ? -1:0 )+
          form.myasthenia +
          form.upperLimbWeakness +
          form.lowerLimbWeakness +
          form.speechDisorders +
          form.visual 
          ;

        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/ROSIERSIGLE.vue